// extracted by mini-css-extract-plugin
module.exports = {"ipd":"Ipd_ipd__Oro_m","add":"Ipd_add__Oph8k","label":"Ipd_label__1GG8-","buttons":"Ipd_buttons__gmNma","buttonsLeft":"Ipd_buttonsLeft__13eeo"};